/* eslint-disable react/prop-types */

/**
 * An onEnter() function that will check to make sure
 * a recipient exists (and is valid) before moving forward.
 */

import logger from 'loglevel'
import React from 'react'
import { Redirect } from 'react-router-dom'
import store from '../stores/configureStore'
import _ from 'lodash'

function onEnter(props) {
  const state = store.getState()
  const url = props.location.pathname.replace(state.server.rootURL, '')
  const rootURL = state.server.rootURL
  const [, flow] = url.split('/')
  const recipient =
    state.recipient || _.get(state, 'server.recipientData.recipient')

  if (
    !recipient.payerId &&
    (!recipient.isRecipientValid ||
      !(recipient.recipient || recipient.recipientId))
  ) {
    logger.warn(
      'A valid payer ID and/or recipient is required to continue through this flow.'
    )
    if (state.external.cancelBackToRoot) {
      return <Redirect to={rootURL} />
    }

    return <Redirect to={`${rootURL}/${flow}`} />
  }
}

export default onEnter
